var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.02 4.126q.027 0 .053.002a1 1 0 0 1 .634.29l7 7 .068.076a1 1 0 0 1-1.406 1.407l-.076-.069L13 7.54v11.586a1 1 0 0 1-2 0V7.54l-5.293 5.293a1 1 0 1 1-1.414-1.414l7-7a1 1 0 0 1 .45-.259q.024-.007.049-.012.016-.004.033-.006a1 1 0 0 1 .154-.015h.041"
  })));
};
export default Svg24;